/** @jsxImportSource @emotion/react */
import { Flex, Text, useTheme } from "basis";
import { SvgInline } from "../SvgInline/SvgInline";

type Props = {
  cardName: string;
  cardEndsWith?: string;
};

function CreditCard({ cardName, cardEndsWith }: Props) {
  const theme = useTheme();

  return (
    <Flex testId="credit-card">
      <div css={{ display: "flex", flexShrink: 0 }}>
        <SvgInline name="credit-card" width="52" height="44" />
      </div>
      <div
        css={{
          marginLeft: theme.space[5],
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Text>
          <strong>{cardName}</strong>
        </Text>
        {cardEndsWith && (
          <Text textStyle="body2" color="grey.t75">
            Card ending {cardEndsWith}
          </Text>
        )}
      </div>
    </Flex>
  );
}

export { CreditCard };
